export default ($stateProvider) => {
  $stateProvider
    .state('login', {
      url: `${location.pathname}login`,
      template: '<nets-login></nets-login>',
    });
};
